import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReferralComponent } from './referral.component';
import { SharedModules } from '../../shared.modules';

@NgModule({
  declarations: [ReferralComponent],
  imports: [
    CommonModule,
    SharedModules
  ]
})
export class ReferralModule { }
